import { createRef } from 'react';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import {
  BlockPagination,
  ContentImage,
} from 'govbr.frontend.policy/components';
import {
  addContentTypesToQuery,
  addMetadataToQuery,
  relativeQuery,
  withQuerystringResults,
} from 'govbr.frontend.policy/helpers';
import PropTypes from 'prop-types';
import { defineMessages } from 'react-intl';
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry';
import { compose } from 'redux';

import ContentDate from '../../ContentDate';

import styles from './ImageListBody.module.less';

const messages = defineMessages({
  noContent: {
    id: 'There are no contents to list.',
    defaultMessage: 'There are no contents to list.',
  },
});

const contentTypes = ['Image'];

const addContentTypes = (query) => {
  return addContentTypesToQuery(query, contentTypes);
};

const metadata_fields = ['modified'];

const addMetadata = (query) => {
  return addMetadataToQuery(query, metadata_fields);
};

const ImageListBody = withQuerystringResults(
  (props) => {
    const {
      isEditMode,
      listingItems,
      totalPages,
      currentPage,
      onPaginationChange,
      prevBatch,
      nextBatch,
      intl,
      hasLoaded,
      data,
    } = props;

    const { title, hideTitles, hideDates } = data;

    const listingRef = createRef();

    if (listingItems.length === 0) {
      return isEditMode && hasLoaded ? (
        <div className="text-danger text-center">
          {intl.formatMessage(messages.noContent)}
        </div>
      ) : null;
    }

    return (
      <div ref={listingRef}>
        {title ? <h2 className="text-center">{title}</h2> : null}
        <ResponsiveMasonry
          className={styles.grid}
          columnsCountBreakPoints={{ 320: 1, 576: 2, 768: 3, 1024: 4, 1600: 5 }}
        >
          <Masonry>
            {listingItems.map((item, index) =>
              item ? (
                <UniversalLink
                  item={item}
                  key={`${item['@id']}-${index}`}
                  className={styles.item}
                >
                  <ContentImage item={item} className={styles.img} />
                  {hideTitles ? null : (
                    <div className={styles.title}>{item.title}</div>
                  )}
                  {hideDates ? null : (
                    <div className={styles.date}>
                      <ContentDate item={item} hideTag hideTime />
                    </div>
                  )}
                </UniversalLink>
              ) : null,
            )}
          </Masonry>
        </ResponsiveMasonry>
        <BlockPagination
          totalPages={totalPages}
          currentPage={currentPage}
          isEditMode={isEditMode}
          listingRef={listingRef}
          onPaginationChange={onPaginationChange}
          prevBatch={prevBatch}
          nextBatch={nextBatch}
        />
      </div>
    );
  },
  compose(addContentTypes, addMetadata, relativeQuery),
);

ImageListBody.propTypes = {
  isEditMode: PropTypes.bool,
};

export default ImageListBody;
